import SideMenu from '@/containers/side-menu/SideMenu.vue'
import Roles from '@/pages/roles/Roles'

export default {
  path: '/roles',
  name: 'Roles',
  components: {
    mainContent: Roles,
    mainMenu: SideMenu
  },
  meta: {
    role: {
      sectorId: 'roles'
    },
    breadcrumb: {
      title: 'Permissões',
      paths: [
        { title: 'Cadastros' },
        { title: 'Permissões' }
      ]
    }
  }
}